<template lang="pug">
  .container-main.container-padding
    .opt-header
      h3 商户资料
      .txt 
        .red(v-if='actuallyStatus === 3') （资料变更存在异常项，请在进入“变更进度查看”页处理）
      .opt 
        el-button(type="primary", @click="toDetail") 变更进度查看
        el-button(type="primary", @click="toEdit") 资料变更
    cBox.display-flex(v-loading="loading", :element-loading-fullscreen="false",v-if='mchDetail.status === 3')
      el-form(:model="mchDetail", label-position="right", label-width="200px")
        template(v-if="mchDetail.type === 1")
          h4 基本信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户主体类型") 公司
              el-form-item(label="公司名称") {{ mchDetail.mch_name || '未填写' }}
              template(v-if="mchDetail.uni_credit")
                el-form-item(label="统一社会信用代码或注册号") {{ mchDetail.uni_credit ||'未填写' }}
              template(v-else)
                el-form-item(label="营业执照号") {{ mchDetail.business_license ||'未填写' }}
                el-form-item(label="组织机构代码") {{ mchDetail.organization_code ||'未填写' }}
                el-form-item(label="税务登记证件号") {{ mchDetail.tex_registration_no ||'未填写' }}
            el-col(:span="12")
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              template(v-if="mchDetail.uni_credit")
                el-form-item(label="营业执照类型") 三证合一，一证一码
              template(v-else)
                el-form-item(label="营业执照类型") 一证三码，三码独立
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image",
                    @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
          hr
          h4 法人信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="法人姓名") {{ mchDetail.legal_per_name || '未填写' }}
              el-form-item(label="法人手机号") {{ mchDetail.legal_per_telephone_no || '未填写' | desensitization }}
              el-form-item(label="身份证(人像面)")
                img(v-if="mchDetail.legal_per_id_positive", :src="mchDetail.legal_per_id_positive | image",
                    @click="$zoom($options.filters.image(mchDetail.legal_per_id_positive))").mch-image
                template(v-else) 未提交
            el-col(:span="12")
              el-form-item(label="法人证件类型") {{ mchDetail.legal_per_id_type | resp_per_id_type }}
              el-form-item(label="法人证件号") {{ mchDetail.legal_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="身份证(国徽面)")
                img(v-if="mchDetail.legal_per_id_opposite", :src="mchDetail.legal_per_id_opposite | image",
                    @click="$zoom($options.filters.image(mchDetail.legal_per_id_opposite))").mch-image
                template(v-else) 未提交
          hr
          h4 责任人信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="责任人姓名") {{ mchDetail.resp_per_name || '未填写' }}
              el-form-item(label="责任人证件号") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
            el-col(:span="12")
              el-form-item(label="责任人证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}

        template(v-if="mchDetail.type === 2")
          //- 个人类型
          h4 基本信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户类型") 个人
              el-form-item(label="个人姓名") {{ mchDetail.resp_per_name || '未填写' }}              
              el-form-item(label="证件号码") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image", @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
            el-col(:span="12")
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              el-form-item(label="证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
              el-form-item(label='') &nbsp;
              el-form-item(label="身份证照片")
                el-row(:gutter="10")
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_positive", :src="mchDetail.resp_per_id_positive | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_positive))").mch-image
                    template(v-else) 未提交
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
                    template(v-else) 未提交
          //- el-row(:gutter="10")
          //-   el-col(:span="12")
          //-     el-form-item(label="证件正面")
          //-       img(v-if="mchDetail.resp_per_id_positive", :src="mchDetail.resp_per_id_positive | image",
          //-         @click="$zoom($options.filters.image(mchDetail.resp_per_id_positive))").mch-image
          //-       template(v-else) 未提交
          //-   el-col(:span="12")
          //-     el-form-item(label="证件反面")
          //-       img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
          //-         @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
          //-       template(v-else) 未提交
          //- h4 商家状态
          //- el-form-item(label="温馨提示", v-if="!mchDetail.resp_per_email && !mchDetail.resp_per_telephone_no") 您的资料还不完整，请尽快补充以免影响业务正常开展。
          //- el-form-item(label="资料审批状态", v-if="mchDetail.status !== 1") {{ mchDetail.status | status }}
          //- el-form-item(label="驳回原因", v-if="mchDetail.status === 4")
          //-   .display-block(v-if="mchDetail.audit_msg") {{ mchDetail.audit_msg }}
          //-   .display-block(v-if="mchDetail.err_msg") {{ mchDetail.err_msg }}
          //- el-form-item(label="") 
          //-   .txt-tip 修改个人资料将需要重新审核
          //-   //- el-button(type="primary", @click="revokeEdit(mchDetail.id)", v-if="mchDetail.status === 2 && mchDetail.id !== 0") 撤回资料编辑
          //-   //- el-button(type="primary", @click="toEdit", v-else) 修改资料
          //-   el-button(type="primary", @click="revokeEdit(mchDetail.id)", v-if="mchDetail.status === 2") 撤回资料编辑
          //-   el-button(type="primary", @click="toEdit", v-if="mchDetail.status === 3 || mchDetail.status === 4 || mchDetail.status === 5") 修改资料
          //- hr
          //- h4 个人联系方式
          //- el-row(:gutter="10")
          //-   el-col(:span="12")
          //-     el-form-item(label="联系地址") {{ mchDetail.business_address || '未填写' }}
          //-     el-form-item(label="")
          //-       el-button(type="primary", @click="showEditContact") 修改联系地址
          //-     el-form-item(label="手机",required) {{ mchDetail.resp_per_telephone_no || '未绑定' | desensitization}}
          //-     el-form-item(label="") 
          //-       el-button(type="primary", @click="toSetPhone") 修改手机号码
          //-   el-col(:span="12")
          //-     el-form-item(label="") &nbsp;
          //-     el-form-item(label="") &nbsp;
          //-     el-form-item(label="邮箱") {{ mchDetail.resp_per_email || '未绑定' }}
          //-     el-form-item(label="") 
          //-       el-button(type="primary", @click="toSetEmail") 修改邮箱地址
    cBox.display-flex(v-loading="loading", :element-loading-fullscreen="false",v-else)
      div 当前没有生效的商家资料，或商家资料审核中。请提交正确的商家资料，并留意审核结果。
    //- el-dialog(title="修改联系方式", :visible.sync="editContact.show")
    //-   el-form(:model="editContact", label-position="right", label-width="125px")
    //-     el-form-item(label="联系地址", required)
    //-       el-input(v-model="editContact.business_address")
    //-     el-form-item(label="商户电话", required, v-if="editContact.type === 1")
    //-       el-input(v-model="editContact.tel")
    //-   .dialog-footer(slot="footer")
    //-     el-button(type="primary", @click="saveEditContact()") 保存
    //-     el-button(@click="hideEditContact()") 取消
    
    verifier(ref="verifyEmail", @success_verify="toModifyEmail", scene="MODIFY_EMAIL", opt="MCH_VERIFY")
    verifier(ref="modifyEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-modify)
    verifier(ref="bindingEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-binding)

    verifier(ref="verifyPhone", @success_verify="toModifyPhone", scene="MODIFY_MOBILE", opt="MCH_VERIFY")
    verifier(ref="modifyPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-modify)
    verifier(ref="bindingPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-binding)

    verifier(ref="editContact", @success_verify="toSaveEditContact", scene="MODIFY_CONTACT", opt="MCH_VERIFY")
</template>

<script>
export default {
  data() {
    return {
      mchDetail: {},
      change_apply_pic: [],
      editContact: {
        show: false,
        type: 1,
        business_address: null,
        tel: null,
      },
      mch_public_draft_list: [{ legal_per_name: "" }],
      loading: false,
      actuallyStatus: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  filters: {
    type(source) {
      switch (source) {
        case 1:
          return "公司";
        case 2:
          return "个人";
        default:
          return source;
      }
    },
    status(source) {
      if (!source && source !== 0) {
        return "-";
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        case 7:
          return "审批中";
        default:
          return source;
      }
    },
    settle_type(source) {
      switch (source) {
        case 1:
          return "银行账号";
        case 2:
          return "钱包账号";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return "身份证";
      }
    },
  },
  methods: {
    getUserInfo() {
      return this.$store.dispatch("GET_USER_INFO");
    },
    getMchDetail() {
      this.loading = true;
      // const { uname } = this.userInfo;
      return this.$store
        .dispatch("LAST_SUCCEED_MCH_DETAIL")
        .then(async (data) => {
          const { status } = await this.$store.dispatch("MCH_AUDIT_STATUS");
          this.actuallyStatus = status;
          this.mchDetail = data;
          if (data.change_apply_pic) {
            this.change_apply_pic = data.change_apply_pic.split(",");
          }
          if (data.mch_public_draft_list && data.mch_public_draft_list.length > 0) {
            this.mch_public_draft_list = data.mch_public_draft_list;
          }
          return data;
        })
        .catch(({ code, msg }) => {
          this.$alert(`商家资料获取失败。${code}：${msg}`, {
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toDetail() {
      this.$router.push("/merchants-information/edit-detail");
    },

    toEdit() {
      if (this.actuallyStatus === 1) {
        this.$alert(`资料变更中，请等待本次变更完成`, {
          type: "error",
        });
        return;
      }
      this.$router.push("/merchants-information/edit");
    },
    showEditContact() {
      this.editContact = {
        show: true,
        type: this.mchDetail.type,
        business_address: this.mchDetail.business_address,
        tel: this.mchDetail.tel,
      };
    },
    hideEditContact() {
      this.editContact = {
        show: false,
        type: 1,
        business_address: null,
        tel: null,
      };
    },
    saveEditContact() {
      if (!this.editContact.business_address) {
        this.$message({
          type: "warning",
          message: `请输入联系地址`,
        });
        return;
      }
      if (this.editContact.type === 1 && !this.editContact.tel) {
        this.$message({
          type: "warning",
          message: `请输入商户电话`,
        });
        return;
      }

      this.$refs.editContact.init();
    },
    toSaveEditContact(biz_ticket) {
      this.loading = true;
      const method =
        this.editContact.type === 1 ? "EDIT_COMPANY_CONTACT" : "EDIT_PERSON_CONTACT";
      this.$store
        .dispatch(method, Object.assign({}, this.editContact, { biz_ticket }))
        .then(() => {
          this.hideEditContact();
          this.getMchDetail();
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `修改失败。${code}：${msg}`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    revokeEdit(mch_draft_id) {
      this.$confirm("是否确认撤回已提交审批的商家信息？", "提示")
        .then(() => {
          return this.$store
            .dispatch("REVOKE_MCH_DRAFT", mch_draft_id)
            .then(() => {
              this.getMchDetail();

              this.$message({
                type: "success",
                message: "撤回成功",
              });
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `撤回失败。${code}：${msg}`,
              });
            });
        })
        .catch(() => {});
    },

    toSetEmail() {
      if (this.mchDetail.resp_per_email) {
        this.toModifyEmail();
      } else {
        this.toBindEmail();
      }
    },
    toBindEmail() {
      this.$refs.bindingEmail.init();
    },
    toModifyEmail(biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyEmail.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyEmail.init(biz_ticket);
      }
    },
    modifyEmailSuccess() {
      this.getMchDetail();
    },

    toSetPhone() {
      if (this.mchDetail.resp_per_telephone_no) {
        this.toModifyPhone();
      } else {
        this.toBindPhone();
      }
    },
    toBindPhone() {
      this.$refs.bindingPhone.init();
    },
    toModifyPhone(biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyPhone.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyPhone.init(biz_ticket);
      }
    },
    modifyPhoneSuccess() {
      this.getMchDetail();
    },
  },
  mounted() {
    // 例如从H5登陆登陆个人高级钱包

    if (this.isMobile) {
      this.$router.replace("/main-mobile");
    }
    this.getUserInfo().then((userInfo) => {
      if (userInfo.fill_info === 1 && this.$route.path !== "/reg/2") {
        this.$router.replace("/reg/2");
      } else {
        this.getMchDetail();
      }
    });
  },
};
</script>
<style lang="less" scoped>
.opt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  h3 {
    // margin: 0;
    font-size: 24px;
    font-weight: 400;
  }
  .txt {
    color: red;
  }
}
</style>
